import { RequestFreightDetail } from 'TypeGen/Order/Load/request-freight-detail';
import { IDNameViewModel } from 'TypeGen/id-name-view-model';
import { formatNumber } from '@progress/kendo-intl';
import { InputSuffix, NumericTextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Link, Typography } from '@mui/material';
import { FreightDetail } from 'TypeGen/Order/Load/freight-detail';

type Props = {
  piecesUnitOfMeasure: IDNameViewModel[];
  data: FreightDetail;
  request: RequestFreightDetail;
  updateRequest: (request: Partial<RequestFreightDetail>) => void;
}

const PiecesInput = ({ data, request, updateRequest, piecesUnitOfMeasure }: Props) => {
  const piecesUoM = (piecesUoM: number) => piecesUnitOfMeasure.find(x => x.ID === piecesUoM)!.Name;
  return <>
    <NumericTextBox
      fillMode={'outline'}
      value={request.Pieces > 0 ? request.Pieces : null}
      placeholder="Pieces"
      min={0}
      style={{ marginTop: '1rem' }}
      spinners={false}
      onChange={(e) => updateRequest({ Pieces: e.value || 0 })}
      suffix={() => (
        <>
          <InputSuffix>
            <DropDownList
              data={piecesUnitOfMeasure}
              textField="Name"
              dataItemKey="ID"
              value={piecesUnitOfMeasure.find(x => x.ID === request.PiecesUnitOfMeasure)}
              onChange={(e) => updateRequest({ PiecesUnitOfMeasure: e.value?.ID || 0 })}
            />
          </InputSuffix>
        </>
      )}
    />
    <Typography
      variant="body2"
      color="textSecondary"
    >
      Requested <Link onClick={() => updateRequest({ Pieces: data.Pieces, PiecesUnitOfMeasure: data.PiecesUnitOfMeasure })}>{formatNumber(data.Pieces, 'n0')} {piecesUoM(data.PiecesUnitOfMeasure)}</Link>
    </Typography>
  </>;
};

export default PiecesInput;